module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidenavbar"
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 auto"
    }
  }, [(_vm.filesOpen) ? _c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goTo('appraisalfiles-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "folder-open",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Files')))])], 1) : _c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goTo('appraisalfiles-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "folder-o",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Files')))])], 1), _vm._v(" "), (_vm.fileOpen) ? _c('ul', {
    staticClass: "navul"
  }, [_c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goToFile()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "folder-open",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.fileNumber))])], 1), _vm._v(" "), (_vm.reportOpen) ? _c('ul', {
    staticClass: "navul"
  }, [_c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goToReport(_vm.reportId)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "file-text",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Report')) + " nº " + _vm._s(_vm.reportNumber) + " (v. " + _vm._s(_vm.versionNumber) + ")")])], 1), _vm._v(" "), (_vm.realEstates) ? _c('ul', {
    staticClass: "navul"
  }, _vm._l((_vm.realEstates), function(realEstate) {
    return _c('li', {
      staticClass: "navli",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.goToRealEstate(realEstate.id)
        }
      }
    }, [(realEstate.id === _vm.realEstateId) ? _c('div', [_c('icon', {
      attrs: {
        "name": "building",
        "scale": "1"
      }
    })], 1) : _c('div', [_c('icon', {
      attrs: {
        "name": "building-o",
        "scale": "1"
      }
    })], 1), _vm._v(" "), _c('span', [(realEstate.street_name) ? _c('span', [_vm._v(_vm._s(realEstate.street_name))]) : _vm._e(), (realEstate.street_number) ? _c('span', [_vm._v(", " + _vm._s(realEstate.street_number))]) : _vm._e(), (realEstate.floor) ? _c('span', [_vm._v(", " + _vm._s(realEstate.floor))]) : _vm._e(), (realEstate.door) ? _c('span', [_vm._v("-" + _vm._s(realEstate.door))]) : _vm._e()])])
  })) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goTo('realestates-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "building-o",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Real_estates')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goTo('ads-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "bookmark-o",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Ads')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goTo('contacts-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "address-card-o",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Contacts')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goTo('appraisalquotes-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "file-powerpoint-o",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Quotes')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goTo('appraisalinvoices-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "eur",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Invoices')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goTo('appraisers-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "user-circle-o",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Appraisers')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goTo('supervisors-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "user-circle",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Supervisors')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goTo('entities-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "university",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Entities')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goTo('becproperties-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "tag",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Construction_prices')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goTo('bdefiles-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "archive",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('BdE_files')))])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4bfe78fa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideNavBar/Index.vue
// module id = 2142
// module chunks = 0